const ETHNICITY_OPTIONS = [
  "Asian",
  "Black / African descent",
  "Hispanic / Latino",
  "Middle Eastern",
  "Native / Indigenous",
  "White / Caucasian",
  "Mixed",
  "Prefer not to say",
];

const EthnicityModal = ({ filters, setFilters, onClose }) => {
  const selected = filters.ethnicity || "";

  const handleToggle = (opt) => {
    setFilters({
      ...filters,
      ethnicity: selected === opt ? null : opt,
    });
  };

  return (
    <div className="w-full relative mt-2">
      {/* Arrow Pointer */}
      <div className="absolute -top-5 left-10 w-4 h-4 bg-white rotate-45 border-l border-t"></div>

      <h2 className="text-lg font-semibold mb-4">Ethnicity</h2>

      <div className="space-y-3 mb-3 max-h-[220px] overflow-y-auto pr-1">
        {ETHNICITY_OPTIONS.map((opt) => (
          <label key={opt} className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              className="w-4 h-4"
              checked={selected === opt}
              onChange={() => handleToggle(opt)}
            />
            <span className="text-sm">{opt}</span>
          </label>
        ))}
      </div>

      <div className="flex justify-between gap-6 mt-2 border-t pt-2">
        <button
          onClick={() => {
            setFilters({ ...filters, ethnicity: null });
            onClose();
          }}
          className="underline text-sm text-gray-700 hover:text-gray-900"
        >
          Clear
        </button>

        <button
          onClick={onClose}
          className="bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition"
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default EthnicityModal;

